import { dateNow, now } from 'utils/core/now';

import type { DateFilter, IBlotterColumnDefinition, Sort } from './blotter.model';

/** deprecated */
export function toUtcDateFromDate(dateFilter: DateFilter, dateNow: Date) {
  const date: Date = new Date(dateNow);

  switch (dateFilter) {
    case 'oneYear':
      date.setFullYear(date.getUTCFullYear() - 1);
      break;
    case 'sixMonths':
      date.setMonth(date.getUTCMonth() - 6);
      break;
    case 'oneMonth':
      date.setMonth(date.getUTCMonth() - 1);
      break;
    case 'twoWeeks':
      date.setDate(date.getUTCDate() - 14);
      break;
    case 'oneWeek':
      date.setDate(date.getUTCDate() - 7);
      break;
    case 'yesterday':
      date.setDate(date.getUTCDate() - 1);
      break;
    default:
  }

  return date;
}

/** deprecated */
export function toUtcDate(dateFilter: DateFilter) {
  const date: Date = toUtcStartOfDay(now());

  return toUtcDateFromDate(dateFilter, date);
}

export function toLocaleDateOnlyString(date: Date): string {
  // Assume that date part of input Date is correct when formatted as local timezone
  // We transform to timezone hours in local timezone ie: midnight in utc
  date.setHours(0, -date.getTimezoneOffset(), 0, 0);
  // We format in utc and truncate time part
  return date.toISOString().slice(0, 10); // yyyy-MM-dd
}

export function toLocaleDate(dateFilter: DateFilter): Date {
  const date = new Date(dateNow());

  switch (dateFilter) {
    case 'oneYear':
      date.setFullYear(date.getFullYear() - 1);
      break;
    case 'sixMonths':
      date.setMonth(date.getMonth() - 6);
      break;
    case 'oneMonth':
      date.setMonth(date.getMonth() - 1);
      break;
    case 'twoWeeks':
      date.setDate(date.getDate() - 14);
      break;
    case 'oneWeek':
      date.setDate(date.getDate() - 7);
      break;
    case 'yesterday':
      date.setDate(date.getDate() - 1);
      break;
    default:
  }

  return date;
}

export function toUtcStartOfDay(date: Date) {
  date.setUTCHours(0, 0, 0, 0);
  return date;
}

export function toUtcEndOfDay(date: Date) {
  date.setUTCHours(23, 59, 59, 999);
  return date;
}

export function getSortFromColumnDefinitions(columnDefinition: readonly IBlotterColumnDefinition[] | undefined) {
  return columnDefinition
    ?.filter(i => i.serverDefaultSort === 'desc' || i.serverDefaultSort === 'asc')
    .map(col => ({ column: col.field, direction: col.serverDefaultSort }) as Sort);
}
